import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreatableSelect from 'react-select/creatable';

import { Receivable } from 'services/action';
import { Button, Modal } from 'react-bootstrap';

import { Form,  Uploader } from 'ui/components';
import pdf from 'ui/assets/pdf.png';
import xlsx from 'ui/assets/xlsx.png';

import _ from 'underscore';

const initialState = {
  shipment_code: '',
  attachments: [],
  additional_charges: 0,
  optionsEmails: null,
};

export const FormPartial = ({ data, updateType, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ shipment_code, attachments, additional_charges, optionsEmails }, setState] =
    React.useState(initialState);

  const $postImage = async(e) => {
    setState((prevState) => ({...prevState, attachments: [...attachments, ...e]}));
  }

  const handleSubmit = async (e) => {
    let emails = []

    _.each(optionsEmails, (i) => {
      emails.push(i?.label)
    })

    const payload = {
      type: updateType,
      shipment_code: shipment_code,
      attachments: attachments,
      additional_charges: additional_charges,
      emails: emails,
    };

    let req = null
    if (data) {
      req = await Dispatch(Receivable.$updatePartial(data?.id, payload));
    }

    if (req?.message === 'success') {
      onClose();
    }
  };

  React.useEffect(() => {
    if (!data) return

    let oe = []
    if (data?.emails) {
      _.each(data?.emails, (i) => {
        oe.push({label: i, value: i})
      })
    }

    setState((prevState) => ({
      ...prevState,
      optionsEmails: oe,
      shipment_code: data?.shipment_code,
      attachments: data?.attachments || [],
      additional_charges: data?.additional_charges
    }));

  }, [data])

  return (
    <>
      <Modal.Body>
        <div className="row text-start">
          <div className="col-md-12">
            {updateType === 'shipment_code' && (
              <Form.Input
                label="Resi"
                type="text"
                value={shipment_code}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    shipment_code: e.target.value,
                  }))
                }
                error={StateForm?.errors?.shipment_code}
                hint="e.g: JNE - 324656789"
              />
            )}


            {updateType === 'emails' && (
              <div className="mb-3">
                <label className='form-label'>Email</label>
                <CreatableSelect
                  value={optionsEmails}
                  classNamePrefix={StateForm?.errors?.emails ? 'is-invalid' : 'select'}
                  placeholder="Enter Emails"
                  style={{backgroundColor: 'rgba(42,255,0,0.3 )'}}
                  className="bg-white"
                  isMulti
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      optionsEmails: e,
                    }))
                  }
                />

                {StateForm?.errors?.emails ? (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {StateForm?.errors?.emails}
                  </div>
                ) : null}
              </div>
            )}

            {updateType === 'additional' && (
              <Form.Input
                value={additional_charges}
                onChange={(e) => {
                  setState((prevState) => ({
                    ...prevState,
                    additional_charges: e.target.valueNumber,
                  }));
                }}
                type="number"
                label="Admin/Return"
                error={StateForm?.errors?.additional_charges}
              />
            )}

            {updateType === 'attachments' && (
              <div>
                <label className="form-label ">Attachments</label>
                <div className="d-flex flex-wrap gap-2 align-items-center justify-content-around pt-2">
                  <Uploader
                    medium
                    setData={(e) => $postImage(e)}
                  />
                  {attachments?.map((d, i) => (
                    <div key={i} style={{ width: 100, height: 100 }}>
                      <img className="img-hover rounded-3" src={`${d?.includes('.pdf') ? pdf : d?.includes('.xlsx') ? xlsx : d}`} alt="" />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button variant="white" className="w-100" onClick={onClose}>
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              variant="primary"
              className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
              onClick={handleSubmit}
              disabled={StateForm?.loading}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
